export interface Protocol17025ChartFile_Interface {
  id:number,
  chart_id:number,
  code:String,
  title:String,
  src:String,
  dsc:String,
}

export function Empty_Protocol17025ChartFile_Interface():Protocol17025ChartFile_Interface{
  return{
    id:0,
    chart_id:0,
    code:'',
    title:'',
    src:'',
    dsc:'',
  }
}
